import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import {
    BASE_RATE_OPTION_TEST_ID,
    GAP_POLICY_BASE_RATE,
    GAP_POLICY_MASK,
    MASK_OPTION_TEST_ID,
    TEST_ID
} from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const GapPolicyToggle: FunctionComponent<Props> = ({
    baseRateLabel,
    className = '',
    gapPolicy,
    maskLabel,
    onGapPolicyChange,
    testId = TEST_ID
}) => {
    const handleMaskClick = () => {
        onGapPolicyChange({ gapPolicy: GAP_POLICY_MASK });
    };

    const handleBaseRateClick = () => {
        onGapPolicyChange({ gapPolicy: GAP_POLICY_BASE_RATE });
    };

    const maskClass = gapPolicy === GAP_POLICY_MASK ? styles.toggleOptionActive : '';
    const baseRateClass = gapPolicy === GAP_POLICY_BASE_RATE ? styles.toggleOptionActive : '';

    return (
        <HorizontalContainer className={`${className} ${styles.gapPolicyToggle}`} testId={testId}>
            <Wrapper
                className={`${maskClass} ${styles.toggleOption}`}
                onClick={handleMaskClick}
                testId={MASK_OPTION_TEST_ID}>
                {maskLabel}
            </Wrapper>

            <Wrapper
                className={`${baseRateClass} ${styles.toggleOption}`}
                onClick={handleBaseRateClick}
                testId={BASE_RATE_OPTION_TEST_ID}>
                {baseRateLabel}
            </Wrapper>
        </HorizontalContainer>
    );
};

export default GapPolicyToggle;
